import { render } from "./AdminSettingsView.vue?vue&type=template&id=27437432&scoped=true"
import script from "./AdminSettingsView.vue?vue&type=script&lang=js"
export * from "./AdminSettingsView.vue?vue&type=script&lang=js"

import "./AdminSettingsView.vue?vue&type=style&index=0&id=27437432&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27437432"]])

export default __exports__